import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBnv3MlYdA-GgZt7s8iT2BJbN7tPa9Nq_0",
  authDomain: "gapcloud-933f5.firebaseapp.com",
  databaseURL: "https://gapcloud-933f5-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gapcloud-933f5",
  storageBucket: "gapcloud-933f5.firebasestorage.app",
  messagingSenderId: "76909688002",
  appId: "1:76909688002:web:59d06503ccf9af6dfcf75b",
  measurementId: "G-ZW0L1S92N4"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;
